export enum SpareStockUomEnum {
    KGS = "KGS",
    MTR = "MTR",
    NUM = "NUM"
}